"use client";
/**
 * The family's one card surface.
 *
 * It exists so the variant modifier is written in exactly one place: the kit's
 * shell owns the geometry, the three regions and the radius rung, and this
 * wrapper only decides which BEM modifier and which debug path the audit
 * tooling reads. The name and the modifier arrive together because the rail
 * card is its own composition and stamps its own name rather than borrowing
 * whichever card the panel has selected.
 */
import type { ReactElement, ReactNode } from "react";
import {
  CresultcardShell,
  type CresultcardDensity,
} from "@/components/ui/Cresultcard";

const ROOT_CLASS_NAME = "cnutritioncard";
const CLASS_NAME_SEPARATOR = " ";

interface CnutritioncardShellProps {
  readonly variant: string;
  readonly modifier: string;
  readonly density: CresultcardDensity;
  readonly head?: ReactNode;
  readonly body: ReactNode;
  readonly foot?: ReactNode;
  readonly openable?: boolean;
}

export function CnutritioncardShell({
  variant,
  modifier,
  density,
  head,
  body,
  foot,
  openable = false,
}: CnutritioncardShellProps): ReactElement {
  return (
    <CresultcardShell
      body={body}
      className={[ROOT_CLASS_NAME, modifier].join(CLASS_NAME_SEPARATOR)}
      density={density}
      foot={foot}
      head={head}
      openable={openable}
      variant={variant}
    />
  );
}
